<template>
    <BasePanel
        headline="lang_LABEL_RELEASES_PANEL_CAPTION_PROFIT_AND_LOSS"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-row >
                <v-card elevation="0">
                    <v-card-text>
                        <v-row>
                            <!-- cols="4" -->
                            <v-col 
                                class="pt-9 pl-2"
                                :alvqa="alvqa + '-result'"
                            >
                                {{ $t('lang_LABEL_STATEMENTS_CAPTION_RESULT') }}:
                                {{ $n(getProfitAndLossResult, 'number') }} {{ $store.getters.getSelectedCurrency }}
                            </v-col>
                            <v-col>
                                <BaseEditPageDatePicker 
                                    :context="context+'Filter'"
                                    field="FromMonth"
                                    :label="$t('lang_GENERIC_CAPTION_PERIOD_FROM')"
                                    :withMargin="false"
                                    :alvqa="alvqa + '-datepicker-from-month'"
                                    type="month"
                                    :clearable="false"
                                />
                            </v-col>
                            <v-col >
                                <BaseEditPageDatePicker 
                                    :context="context+'Filter'"
                                    field="ToMonth"
                                    :label="$t('lang_GENERIC_CAPTION_PERIOD_TO')"
                                    :withMargin="false"
                                    :alvqa="alvqa + '-datepicker-to-month'"
                                    type="month"
                                    :clearable="false"
                                />
                            </v-col>
                            <span class="pt-6">
                                <BaseIcon 
                                    :alvqa="alvqa + '-icon-search'"
                                    @click="filter" 
                                    icon="fa-search" 
                                    tooltipText="lang_GENERAL_CAPTION_START_SEARCH" 
                                />
                            </span>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-row>
            <ProjectsProfitAndLossCostsDataTableReadOnly :projectsAlvId="projectsAlvId" />
            <ProjectsProfitAndLossIncomeDataTableReadOnly :releaseAlvId="projectsAlvId" class="pt-3" />
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'

import ProjectsProfitAndLossCostsDataTableReadOnly from './ProjectsProfitAndLossCostsDataTableReadOnly'
import ProjectsProfitAndLossIncomeDataTableReadOnly from './ProjectsProfitAndLossIncomeDataTableReadOnly'

export default {
    name: 'ProjectsProfitAndLossReadOnlyPanel',
    components: {
        BasePanel,
        BaseEditPageDatePicker,
        BaseIcon,
        BaseButton,

        ProjectsProfitAndLossCostsDataTableReadOnly,
        ProjectsProfitAndLossIncomeDataTableReadOnly
    },
    props: {
        projectsAlvId: {
            type: String
        }
    },
    data() {
        return {
            context: "ProjectProfitAndLoss",
            alvqa: 'label-projects-list-row-' + this.projectsAlvId + '-read-only-panel-profit-loss'
        }
    },
    computed: {
        getProfitAndLossResult: { 
            get() { return this.$store.getters.getProjectsProfitAndLossResult },
            set(value) { this.$store.commit('setProjectsProfitAndLossResult', value)}
        }
    },
    methods: {
        filter() {
            this.$store.commit('setSelectedProjectsProfitAndLossFilterCostGroup', null)
            this.$store.commit('setSelectedProjectsProfitAndLossFilterIncomeGroup', null)

            this.$store.dispatch('fetchProjectsProfitAndLoss')
        },
    },
    created() {
        // set default for "to month" and "from month" datepicker filter
        this.$store.commit('setProjectProfitAndLossFilterDetailsToMonth',this.$alvPlugin.dateToISOFormat(new Date())) 
        this.$store.commit('setProjectProfitAndLossFilterDetailsFromMonth', this.$alvPlugin.dateToISOFormat(new Date("2008", 0)))

        this.$store.dispatch('fetchProjectsProfitAndLoss')
    }
}
</script>